/* eslint-disable max-len */
import './gallery.scss';
// File for slideshow version only
import './gallery-slideshow.scss';
import Ellipsis from 'ellipsis.js';

const selectors = [
  '.wp-block-image figcaption',
  '.widget_media_gallery .gallery-caption',
  '#featured-image-caption',
  '#featured-image-caption-2',
];

// Ellipsis config.
const ellipsis = Ellipsis({
  lines: 2,
  break_word: false,
  responsive: true,
});

function galleryTruncation() {
  const galleryContainer = document.querySelector('.wp-block-jetpack-slideshow_container');
  if (! galleryContainer || (galleryContainer && ! galleryContainer.classList.contains('swiper-container-initialized'))) {
    setTimeout(() => {
      galleryTruncation(); // Check again after 500ms
    }, 500);
    return false; // Indicate need for further checking
  }

  const figcaptionElements = document.querySelectorAll('.wp-block-jetpack-slideshow_caption.gallery-caption');
  if (figcaptionElements && 0 < figcaptionElements.length) {
    figcaptionElements.forEach((element) => {
      // Get the original text content
      let originalContent = element.textContent.trim();
      originalContent = originalContent.replace(/Read More »/g, '');
      // Get the computed font size of the caption element
      const computedFontSize = window.getComputedStyle(element).fontSize;

      // Create a temporary span element to calculate the size of the text
      const tempSpan = document.createElement('span');
      tempSpan.style.whiteSpace = 'nowrap';
      tempSpan.style.position = 'fixed'; // Use "fixed" for accurate width calculation
      tempSpan.style.left = '-9999px'; // Move the element off-screen
      tempSpan.style.fontSize = computedFontSize; // Set the computed font size
      document.body.appendChild(tempSpan);

      let wordCount = 1;
      let isAddedDots = true;

      let swiperContainer = element;
      while (swiperContainer && ! swiperContainer.classList.contains('swiper-container')) {
        swiperContainer = swiperContainer.parentElement;
      }

      const maxWidth = swiperContainer.offsetWidth - 34;
      while (tempSpan.offsetWidth <= maxWidth) {
        wordCount += 1;
        const trimmedContent = originalContent.split(' ').slice(0, wordCount).join(' ');
        tempSpan.textContent = `${trimmedContent} ...`;
        if (trimmedContent === originalContent) {
          isAddedDots = false;
          break;
        }
      }

      tempSpan.remove();

      if (isAddedDots) {
        wordCount -= 1; // Reduce one word to fit within the available width
        const trimmedContent = originalContent.split(' ').slice(0, wordCount).join(' ');

        // Create the span element for the truncated caption
        const truncatedSpan = document.createElement('span');
        truncatedSpan.classList.add('figcaption-short-wrap');
        if (isAddedDots) {
          truncatedSpan.innerText = `${trimmedContent} ...`;
        } else {
          truncatedSpan.innerText = originalContent;
        }
        // Create the span element for the original content
        const originalSpan = document.createElement('span');
        originalSpan.classList.add('figcaption-long-wrap');
        originalSpan.textContent = originalContent;

        const buttonElement = document.createElement('button');
        buttonElement.className = 'caption-toggle__button';

        /* eslint-disable no-param-reassign */
        element.innerHTML = '';
        if (truncatedSpan) {
          element.appendChild(truncatedSpan);
        }
        if (originalSpan) {
          element.appendChild(originalSpan);
        }
        if (buttonElement) {
          element.appendChild(buttonElement);
        }
      } else {
        const buttonElement = element.querySelector('.caption-toggle__button');
        if (buttonElement) {
          buttonElement.remove();
        }
      }
    });
  }
  // Get all the caption-toggle__button elements
  const toggleButtons = document.querySelectorAll('.wp-block-jetpack-slideshow_caption.gallery-caption .caption-toggle__button');
  toggleButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const figcaption = button.closest('.gallery-caption');
      figcaption.classList.toggle('caption-toggle--expanded');
    });
  });

  return true;
}

window.addEventListener('load', () => {
  galleryTruncation();
});

const BUTTON_READ_MORE_STYLE = `
  background: transparent;
  border: none;
  color: #1C1C1C;
  cursor: pointer;
  font-style: italic;
  font-weight: 700;
  outline: none;
`;

/**
 *
 * @param {Object} truncatedText The element with truncated text.
 * @param {Object} fullText The element with the full text.
 * @param {Object} readMore The readMore button.
 *
 * Toggles between the full text and the truncated text elements.
 */
const toggleReadMore = (truncatedText, fullText, readMore) => {
  /* eslint-disable no-param-reassign */
  if ('none' === fullText.style.display) {
    fullText.style.display = 'flex';
    truncatedText.style.display = 'none';
    readMore.textContent = 'Read Less';
  } else {
    fullText.style.display = 'none';
    truncatedText.style.display = 'flex';
    readMore.textContent = 'Read More';
  }
};

/**
 *
 * @param {object} el The html element to count lines from.
 *
 * Count the lines of an html element.
 */
const countLines = (el) => {
  const elementHeight = el.offsetHeight;
  const lineHeight = parseInt(el.style.lineHeight, 10) || 20;
  const lines = elementHeight / lineHeight;
  return lines;
};

selectors.forEach((selector) => {
  const elements = document.querySelectorAll(selector);
  const fullTextClass = `${selector.substring(1).replace(/ .*/, '')}-full`;
  // If there are elements with this selector.
  if (elements) {
    elements.forEach((element) => {
      // When there is a gallery, 'Read More' appears after 4 lines
      if ('.widget_media_gallery .gallery-caption' === selector && 4 < countLines(element)) {
        // Creates a read more button.
        const readMore = document.createElement('button');
        readMore.classList.add('caption-read-more-button');
        /*
          In some stations the caption-read-more-button class
          doesn't apply styles to these buttons for unknown reasons (same with any other class)
          So we assign the styles here in the script.
        */
        readMore.style.cssText = BUTTON_READ_MORE_STYLE;
        readMore.textContent = 'Read More';
        // We duplicate the element to have a version with the full text.
        const elementFullText = element.cloneNode(true);
        elementFullText.classList.add(fullTextClass);
        elementFullText.style.display = 'none';
        // We add both the read more button and the full text version to the element container.
        element.parentNode.appendChild(elementFullText);
        element.parentNode.appendChild(readMore);
        const isImageBlock = elementFullText.className.includes('wp-block-image');
        if (isImageBlock) {
          const imageWidth = element.parentNode.querySelector('img').offsetWidth;
          element.style.display = 'block';
          element.style.maxWidth = `${imageWidth}px`;
          elementFullText.style.maxWidth = `${imageWidth}px`;
        }
        readMore.onclick = () => {
          toggleReadMore(element, elementFullText, readMore);
        };
      } else if (2 < countLines(element)) {
        // Creates a read more button.
        const readMore = document.createElement('button');
        readMore.classList.add('caption-read-more-button');
        /*
          In some stations the caption-read-more-button class
          doesn't apply styles to these buttons for unknown reasons (same with any other class)
          So we assign the styles here in the script.
        */
        readMore.style.cssText = BUTTON_READ_MORE_STYLE;
        readMore.textContent = 'Read More';
        // We duplicate the element to have a version with the full text.
        const elementFullText = element.cloneNode(true);
        elementFullText.classList.add(fullTextClass);
        elementFullText.style.display = 'none';
        // We add both the read more button and the full text version to the element container.
        element.parentNode.appendChild(elementFullText);
        element.parentNode.appendChild(readMore);
        element.parentNode.classList.add('caption-has-read-more');
        const isImageBlock = elementFullText.className.includes('wp-block-image');
        if (isImageBlock) {
          const imageWidth = element.parentNode.querySelector('img').offsetWidth;
          element.style.display = 'block';
          element.style.maxWidth = `${imageWidth}px`;
          elementFullText.style.maxWidth = `${imageWidth}px`;
        }
        readMore.onclick = () => {
          toggleReadMore(element, elementFullText, readMore);
        };
      }
    });
    ellipsis.add(elements);
  }
});

// Ellipsis config for gallery block.
const galleryBlockConfig = Ellipsis({
  /* We set 4 lines instead of 1 because we need some padding on top of each gallery item
  and this extra space counts as 3 extra lines. */
  lines: 4,
  responsive: true,
  break_word: false,
});

const galleryBlocks = document.querySelectorAll('.blocks-gallery-item__caption');

if (0 !== galleryBlocks.length) {
  galleryBlocks.forEach((element) => {
    // We duplicate the element to have a version with the full text.
    const elementFullText = element.cloneNode(true);
    elementFullText.style.display = 'none';

    elementFullText.classList.add('blocks-gallery-item__caption--full-text');
    element.classList.add('blocks-gallery-item__caption--trunc-text');

    // Removing main class so they dont get handled by the block scripts
    elementFullText.classList.remove('blocks-gallery-item__caption');
    element.classList.remove('blocks-gallery-item__caption');

    if (4 < countLines(element)) {
      element.parentNode.appendChild(elementFullText);

      // Toogle Button
      const toogleButton = document.createElement('button');
      toogleButton.classList.add('caption-toggle__button');

      // Screen reader text.
      const toogleButtonText = document.createElement('span');
      toogleButtonText.classList.add('screenreadertext');
      toogleButtonText.textContent = 'Read More »';

      toogleButton.appendChild(toogleButtonText);
      element.parentNode.appendChild(toogleButton);

      toogleButton.addEventListener('click', () => {
        if ('none' === elementFullText.style.display) {
          elementFullText.style.display = 'block';
          element.style.display = 'none';
          toogleButton.classList.add('caption-toggle__button--full-text');
        } else {
          elementFullText.style.display = 'none';
          element.style.display = 'block';
          toogleButton.classList.remove('caption-toggle__button--full-text');
        }
      });
    }
  });
  galleryBlockConfig.add(document.querySelectorAll('.blocks-gallery-item__caption--trunc-text'));
}
